module.exports = __webpack_public_path__ + "static/media/logo_combined.62ba0e19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_combined.svg
// module id = 20
// module chunks = 0